import { useEffect, useState } from 'react';

export default function useOrkestaPayCard() {
  const [scriptIsLoaded, setScriptIsLoaded] = useState(false);

  const isSandBox =
    process.env.NEXT_PUBLIC_ORKESTA_SANDBOX === 'true'
      ? { is_sandbox: true }
      : {};

  const createOrkestaPay = () =>
    window.initOrkestaPay({
      ...isSandBox,
      merchant_id: process.env.NEXT_PUBLIC_ORKESTA_MERCH_ID,
      public_key: process.env.NEXT_PUBLIC_ORKESTA_KEY,
    });

  const createCard = async (orkestapay) => {
    const card = await orkestapay.createCard({
      card_number: document.querySelector('#cardNumber'),
      expiration_date: document.querySelector('#validity'),
      verification_code: document.querySelector('#cvv'),
      holder_name: document.querySelector('#name'),
    });
    return card;
  };

  const createDeviceInfo = async (orkestapay) => {
    const response = await orkestapay.getDeviceInfo();
    return response;
  };

  const subscribeToErrors = (card) => {
    const mergeErrors = (...streams) => {
      streams.forEach((stream) =>
        stream.subscribe((err) => {
          if (err) console.error('Field error', err);
        }),
      );
    };
    mergeErrors(
      card.card_number.errors$,
      card.expiration_date.errors$,
      card.verification_code.errors$,
      card.holder_name.errors$,
      card.holder_last_name.errors$,
    );
  };

  const subscribeToPromotions = (card) => {
    card.card_number.promotions$.subscribe((data) => {
      const promoOptions = [];
      data.forEach((type) => {
        type.installments.forEach((promo) => {
          promoOptions.push({ value: promo, label: `${promo} ${type.type}` });
        });
      });
    });
  };

  useEffect(() => {
    const loadScript = () => {
      if (document.querySelector('#orkestapay-script')) {
        setScriptIsLoaded(true);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.orkestapay.com/script/orkestapay.js';
      script.id = 'orkestapay-script';
      script.async = true;
      document.body.appendChild(script);

      setScriptIsLoaded(true);
    };

    loadScript();
  }, []);

  const createToken = async (oneTimeUse = true) => {
    const orkestapay = window?.orkestaPay || createOrkestaPay();

    try {
      const deviceInfo = await createDeviceInfo(orkestapay);
      const card = await createCard(orkestapay);
      subscribeToErrors(card);
      const token = await card.createToken({ one_time_use: oneTimeUse });

      return { token, deviceInfo };
    } catch (error) {
      return { error };
    }
  };

  return {
    createToken,
  };
}
